export const layout = (component: string) => {
    return import(`@/layouts/${component}.vue`);
};